<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-08-23 10:32:11
 * @LastEditTime: 2022-04-23 11:50:05
 * @FilePath: \raacfold\src\components\information\BlastHits.vue
-->
<template>
    <el-scrollbar :style="{height: mainHeight, background:'white'}">
        <div>
            <table class="bm-table" style="margin:0px;">
                <tr class="table-header">
                    <td colspan="2" style="text-align: center">Base Information</td>
                </tr>
                <tr v-if="JSON.stringify(protein_uniprot) !== '{}'">
                    <td class="bm-table-name">Organism</td>
                    <td class="bm-table-ope">
                        <el-input v-model="protein_uniprot['organism']['names'][0]['value']" placeholder="">
                        </el-input>
                    </td>
                </tr>
                <tr v-if="current_hit['description']">
                    <td class="bm-table-name">Protein </td>
                    <td class="bm-table-ope">
                        <p>
                           {{current_protein.accession}}
                            <a :href="`https://www.uniprot.org/uniprot/${current_protein.accession}`" target="_blank"><img title="UniProt Protein Database" alt="UniProt Protein Database" src="../../../public/img/uniprot_btn.png" style="height:20px; cursor: pointer; padding:0 0 0 5px"/></a>
                            </p>
                    </td>
                </tr>
                <tr v-if="JSON.stringify(protein_uniprot) !== '{}'">
                    <td class="bm-table-name">Full Name</td>
                    <td class="bm-table-ope">
                        <el-input v-model="protein_uniprot['protein']['recommendedName']['fullName']['value']" placeholder="">
                        </el-input>
                    </td>
                </tr>
                <tr  v-if="current_protein['source_db'] === 'AlphaFold'">
                    <td class="bm-table-name">Structure</td>
                    <td class="bm-table-ope">
                        <p class="info-p"> {{current_protein.source_db}} ({{current_protein.accession}}) <a :href="`https://alphafold.ebi.ac.uk/entry/${current_protein.accession}`" target="_blank"><img title="AlphaFold Protein Structure Database" alt="AlphaFold Protein Structure Database" src="../../../public/img/alphafold_btn.png" style="height:20px; cursor: pointer; padding:0 0 0 5px"/></a></p>
                    </td>
                </tr>
                <tr v-if="current_protein['source_db'] === 'PDB'">
                    <td  class="bm-table-name">Structure</td>
                    <td class="bm-table-ope">
                        <p class="info-p"> {{current_protein.source_db}} ({{current_protein.pdb_id}}) <a :href="`https://www.rcsb.org/structure/${current_protein.pdb_id}`" target="_blank"><img title="Protein Data Bank" alt="Protein Data Bank" src="../../../public/img/pdb_btn.png" style="height:16px; cursor: pointer; padding:0 0 0 5px"/></a></p>
                    </td>
                </tr>
                <tr>
                <td class="bm-table-name">Raac</td>
                    <td class="bm-table-ope">
                        <p class="info-p"> {{raac_info.method}} ({{raac_info.raac_id}})</p>
                    </td>
                </tr>
                <!-- <tr>
                    <td class="bm-table-name">Description</td>
                    <td class="bm-table-ope">
                        <p class="info-p"> {{raac_info.descriptions}} </p>
                    </td>
                </tr> -->
                <div style="display: none">
                    <tr>
                        <td class="bm-table-name">Evalue</td>
                        <td class="bm-table-ope">
                            <p>{{current_hsp.evalue}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="bm-table-name">Positives</td>
                        <td class="bm-table-ope">
                            <p>{{current_hsp.positive}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="bm-table-name">align_len</td>
                        <td class="bm-table-ope">
                            <p>{{current_hsp.align_len}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="bm-table-name">identities</td>
                        <td class="bm-table-ope">
                            <p>{{current_hsp.identity}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="bm-table-name">Gaps</td>
                        <td class="bm-table-ope">
                            <p>{{current_hsp.gaps}}</p>
                        </td>
                    </tr>
                </div>
            </table>
        </div>
        <div>
            <table class="bm-table" style="margin-bottom: 0px;">
                <tr class="table-header">
                    <td colspan="2" style="text-align: center">Similarity of Proteins</td>
                </tr>
            </table>
            <el-scrollbar :style="{height: winHeight}">
                <div id="container" :style="{height: hits_chart_height}"></div>
                <img class="img-responsive center-block" src="../../../public/img/blast_legend.svg">
            </el-scrollbar>
            <table class="bm-table" style="margin-bottom: 0px;">
                <tr class="table-header">
                    <td colspan="2" style="text-align: center">Distribution of Reduced Amino Acid Clusters</td>
                </tr>
            </table>
            <el-scrollbar :style="{height: reduceWinHeight}" v-loading="is_loading">
                <el-container v-if="is_show_sankey" style="overflow-x:hidden">
                    <el-aside width="20px" style="border-right: none !important;overflow-x:hidden">
                        <div v-if="is_show_aside" :style="{borderRight: '1px solid #cccccc !important', writingMode: 'vertical-rl', textAlign: 'center', height: reduce_chart_height, overflowX:'hidden'}">
                            Natural Amino Acid Clusters</div>
                    </el-aside>
                    <el-main style="padding: 0px;">
                        <div id="reduced_sankey1" :style="{height: reduce_chart_height, width: '100%'}"></div>
                    </el-main>
                    <el-aside width="20px"
                        style="border-right: none !important;overflow-x:hidden">
                        <div v-if="is_show_aside" :style="{borderLeft: '1px solid #cccccc !important', writingMode: 'vertical-rl', textAlign: 'center', height: reduce_chart_height, overflowX:'hidden'}">
                            Reduced Amino Acid Clusters</div>
                    </el-aside>
                </el-container>
                <div v-if="!is_show_sankey" style="color: #747d8c; padding: 10px">
                        <i class="el-icon-question"></i>
                        In the <strong>Sequence Viewer</strong>, <strong> Mouse swipe the sequence</strong> to analysis Distribution of Reduced Amino Acid Clusters.
                        
                        <br><i class="el-icon-warning"></i>
                        Only count the reduced amino acid clusters in the visible region.
                </div>
            </el-scrollbar>
        </div>

    </el-scrollbar>
</template>

<script>
    import Highcharts from 'highcharts'
    import gantt from 'highcharts/modules/gantt'
    gantt(Highcharts);
    import * as highchartsSankey from 'highcharts/modules/sankey';
    highchartsSankey(Highcharts);
    import highchartsMore from 'highcharts/highcharts-more';
    import loadExporting from 'highcharts/modules/exporting';
    import exportExcel from 'highcharts/modules/export-data';
    highchartsMore(Highcharts);
    loadExporting(Highcharts);
    exportExcel(Highcharts);

    export default {
        name: "BlastResPlot",
        data() {
            return {
                mainHeight: window.innerHeight - 90 + "px",
                winHeight: 240 + "px",
                reduceWinHeight: 350 + "px",
                hits_chart_height: 230 + "px",
                reduce_chart_height: 340 + "px",
                current_hit: [],
                current_hsp: [],
                total_title: "",
                hits: [],
                current_protein: {},
                current_range: {},
                current_sequence_menu_range: {
                    range: {
                        start: 0,
                        end: 1000000000
                    },
                    delete: [''],
                },
                is_init: true,
                is_show_sankey: true,
                raac_info:{},
                protein_uniprot:{},
                is_loading: false,
                is_show_aside: false,
            }
        },
        watch: {
            '$store.state.align_hits'(res) {
                // console.log("----->", res);
                this.hits = res['hits'];
                this.hits_chart_height = 80 + this.hits.length * 20 + 'px';
                this.current_hit = this.hits[0];
                this.current_hsp = this.current_hit['hsps'][0];
                this.moreChart(this.hits);
            },
            '$store.state.protein_uniprot'(res) {
                this.protein_uniprot = res;
            },
            '$store.state.raac_scheme'(val) {
                this.raac_scheme = val;
                this.current_range = undefined;
                if(this.current_protein !== undefined)
                this.render_reduce_aa(this.current_protein, this.current_range)
            },
            "$store.state.raac_color"(val) {
                this.raac_color = val;
                if(this.current_protein !== undefined)
                this.render_reduce_aa(this.current_protein, this.current_range)
            },
            '$store.state.current_protein'(res, res1) {
                // console.log(">>>", res)
                this.update_current_hist(res);
                if (res['accession'] !== res1['accession'] || this.is_init) {
                    this.render_reduce_aa(res);
                    this.current_protein = res;
                }
                if (res['source_db'] !== res1['source_db'] || res['pdb_id'] !== res1['pdb_id'] || res['accession'] !== res1['accession'] ) {
                    this.current_protein = res;
                    this.current_db = this.current_protein['source_db']
                }
            },
            '$store.state.selected_range'(res) {
                this.current_range = res;
            },
            '$store.state.raac_info'(res) {
                // console.log("$store.state.raac_info", res)
                this.raac_info = res;
            },
            "$store.state.sequence_menu"(obj) {
                if (obj['delete'] !== undefined && obj['range'] !== undefined && this.current_sequence_menu_range['range'] !== undefined) {
                    if (!CompareArray(JSON.parse(JSON.stringify(this.current_sequence_menu_range['delete'])), JSON.parse(JSON.stringify(obj['delete']))) || !Compare(JSON.parse(JSON.stringify(this.current_sequence_menu_range['range'])), JSON.parse(JSON.stringify(obj['range'])))) {
                        if(!this.is_init)
                            this.render_reduce_aa(this.current_protein, obj);
                    }
                    this.current_range = obj;
                    this.current_sequence_menu_range['range'] = obj['range'];
                }
            },
        },
        mounted() {},
        methods: {
            render_reduce_aa(res, data) {
                // console.log("render_reduce_aa", res['natural_seq'])
                this.is_show_aside = false;
                let natural_seq = res['natural_seq'];
                if (natural_seq !== undefined && !this.is_loading) {
                    // console.log("sequence_init")
                    // let reduced_seq = res['reduced_seq'];
                    let reduced_seq = this.get_reduced_seq(natural_seq);
                    // let start = ;
                    // let end = ;
                    let starts = [1];
                    let ends = [natural_seq.length];
                    let deletes = [];
                    let aa_map = {};
                    let range = {};
                    let seleted_colors = this.$store.state.raac_color;
                    let reduced_colors = {};
                    let seleted_scheme = this.$store.state.raac_scheme;
                    let all_colors = []
                    seleted_scheme.forEach(function(item, i) {
                        for (let j = 0; j < item.length; j++) {
                            reduced_colors[item[j]] = seleted_colors[i];
                        }
                    })
                    let natural_colors = {
                        A: "#f3a683",
                        C: "#cf6a87",
                        D: "#e77f67",
                        E: "#f5cd79",
                        F: "#ea8685",
                        G: "#546de5",
                        H: "#e15f41",
                        I: "#c44569",
                        K: "#f8a5c2",
                        L: "#786fa6",
                        M: "#63cdda",
                        N: "#778beb",
                        P: "#596275",
                        Q: "#f19066",
                        R: "#f7d794",
                        S: "#574b90",
                        T: "#f78fb3",
                        V: "#303952",
                        W: "#3dc1d3",
                        Y: "#e66767",
                    };
                    reduced_colors
                    natural_colors
                    // for(let key in natural_colors){
                    //     all_colors.push(natural_colors[key])
                    // }
                    // console.log("render_reduce_aa", reduced_colors, natural_colors)
                    if (data !== undefined) {
                        if (Object.prototype.hasOwnProperty.call(data, 'range')) {
                            range = data['range']
                            starts = range['start'];
                            ends = range['end'];
                            deletes = data['delete'];
                        }
                    }
                    // console.log("deletes", deletes)

                    for (let j = 0; j < starts.length; j++) {
                        let start = starts[j] - 1;
                        let end = ends[j];
                        for (let i = start; i < end; i++) {
                            let natural_aa = natural_seq[i];
                            let reduced_aa = reduced_seq[i];
                            let map_key = natural_aa + "," + reduced_aa;
                            if(deletes.length > 0){
                                if(!deletes[j]){
                                    if (Object.prototype.hasOwnProperty.call(aa_map, map_key)) {
                                        aa_map[map_key] += 1
                                    } else {
                                        aa_map[map_key] = 1
                                    }
                                }
                            }else{
                                if (Object.prototype.hasOwnProperty.call(aa_map, map_key)) {
                                    aa_map[map_key] += 1
                                } else {
                                    aa_map[map_key] = 1
                                }
                            }
                            
                        }
                    }

                    let links = [];
                    let natural_list = [];
                    let reduced_list = [];
                    let data_list = [];
                    let data_dict = [];
                    let nodes_colors = {};
                    for (let key in aa_map) {
                        let source = key.split(",")[0];
                        let target = key.split(",")[1];
                        data_list.pushNoRepeat(source);
                        data_list.pushNoRepeat(target + " ");
                        natural_list.push(source);
                        reduced_list.push(target);
                        links.push({
                            color: natural_colors[source],
                            from: source,
                            to: target + " ",
                            weight: aa_map[key]
                        })
                        nodes_colors[source] = natural_colors[source];
                        nodes_colors[target + " "] = reduced_colors[target];
                    }

                    for (let key in nodes_colors) {
                        all_colors.push(nodes_colors[key])
                    }

                    // console.log("links", links)
                    data_list.forEach(item => {
                        data_dict.push({
                            name: item
                        })
                    });

                    if(links.length > 0){
                        this.is_show_sankey = true;
                        this.is_loading = true;
                        setTimeout(() => {
                            Highcharts.chart('reduced_sankey1', {
                            chart: {
                                // inverted: true
                            },
                            title: {
                                enabled: false,
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            series: [{
                                name: 'Reduced amino acids',
                                keys: ['from', 'to', 'weight'],
                                data: links,
                                type: 'sankey',
                                colors: all_colors,
                                cursor: 'pointer',
                                centerInCategory: true,
                                dataLabels: {
                                    allowOverlap: true,
                                    crop: false,
                                    overflow: 'allow',
                                    align: 'center',
                                    padding: 2,
                                }
                            }],
                        });
                    }, 2000);
                        this.is_show_aside = true;
                        this.is_loading = false;               
                    }else{
                        this.is_show_sankey = false;
                    }


                    
                }
                this.is_init = false;
                
            },
            data_process() {
                this.current_protein['reduced_seq'] = this.get_reduced_seq(this.current_protein['reduced_seq']);
            },
            get_reduced_seq(natural_seq) {
                let raac_scheme = this.$store.state.raac_scheme;
                let reduced_seq = "";
                let reduced_map = {};
                raac_scheme.forEach((item) => {
                    let replace_aa = item.substr(0, 1);
                    for (let i = 0; i < item.length; i++) {
                        reduced_map[item[i]] = replace_aa
                    }
                });
                // console.log("natural_seq", natural_seq)
                for (let i = 0; i < natural_seq.length; i++) {
                    reduced_seq += reduced_map[natural_seq[i]];
                }
                return reduced_seq;
            },
            init() {

            },
            update_current_hist(res) {
                let current_accession = res['accession'];
                this.hits.forEach((hit) => {
                    let hit_accession = hit['description'][0]['title'].split("|")[1];
                    if (hit_accession === current_accession) {
                        this.current_hit = hit;
                        this.current_hsp = hit['hsps'][0];
                    }
                })
            },
            moreChart(hits) {
                if (this.chart) {
                    this.chart.destroy();
                }
                Highcharts.createElement('link', {
                    // href: 'http://fonts.googleapis.com/css?family=Dosis:400,600',
                    rel: 'stylesheet',
                    type: 'text/css'
                }, null, document.getElementsByTagName('head')[0]);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#f7a35c", "#90ee7e", "#7798BF", "#aaeeee", "#ff0066", "#eeaaee",
                        "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"
                    ],
                    chart: {
                        backgroundColor: null,
                        style: {
                            fontFamily: "Dosis, sans-serif"
                        }
                    },
                    title: {
                        style: {
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                        }
                    },
                    tooltip: {
                        // borderWidth: 0,
                        backgroundColor: 'rgba(219,219,216,0.6)',
                        // shadow: false
                        // backgroundColor: '#FCFFC5',   // 背景颜色
                        borderColor: 'rgba(219,219,216)', // 边框颜色
                        borderRadius: 10, // 边框圆角
                        borderWidth: 1, // 边框宽度
                        // shadow: ture,                 // 是否显示阴影
                        // animation: true               // 是否启用动画效果
                        style: { // 文字内容相关样式
                            color: 'black',
                            fontSize: "12px",
                            fontWeight: "blod",
                            fontFamily: "Courir new"
                        }
                    },
                    legend: {
                        itemStyle: {
                            fontWeight: 'bold',
                            fontSize: '13px'
                        }
                    },
                    xAxis: {
                        gridLineWidth: 1,
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    yAxis: {
                        minorTickInterval: 'auto',
                        title: {
                            style: {
                                textTransform: 'uppercase'
                            }
                        },
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    plotOptions: {
                        candlestick: {
                            lineColor: '#404048'
                        }
                    },
                    background2: '#F0F0EA'
                };
                Highcharts.setOptions(Highcharts.theme);
                // 初始化 Highcharts 图表
                // let title = "Distribution of " + hits.length + " Blast Hits on the Query Sequence";
                let title = "Similarity of " + hits.length + " Proteins";
                this.total_title = title;
                let y_categories = [];
                let data = [];
                let subtitle = "";
                // console.log(hits)
                let hits_length = hits.length - 1;
                hits.forEach((item, i) => {
                    let accession = item["description"][0]['title'].split("|")[1];
                    item['hsps'].forEach((hsp) => {
                        data.push({
                            x: hsp['query_from'],
                            x2: hsp['query_to'],
                            y: hits_length - i,
                            color: this.hit_color(hsp['score'])
                        })
                    });
                    y_categories.push(accession)
                });
                y_categories = y_categories.reverse();
                data = data.reverse();
                // console.log(document.getElementById('container11'));
                // console.log("container", );
                let container = document.getElementById('container');
                if (container !== null) {
                    container.innerHTML = '<div id="container_blast" style="height: ' + this.hits_chart_height +
                        ';"></div>';
                    this.chart = new Highcharts.Chart('container_blast', {
                        chart: {
                            type: 'xrange'
                        },
                        title: {
                            text: ""
                        },
                        subtitle: {
                            text: subtitle
                        },
                        legend: {
                            enabled: false
                        },
                        credits: {
                            enabled: false
                        },
                        xAxis: {},
                        yAxis: {
                            title: {
                                text: ''
                            },
                            categories: y_categories,
                        },
                        tooltip: {},
                        series: [{
                            name: '',
                            // pointPadding: 10000,
                            // groupPadding: 10000,
                            // borderColor: 'gray',
                            pointWidth: 10,
                            data: data,
                            dataLabels: {
                                enabled: true
                            }
                        }],
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                // point: {
                                //     events: {
                                //         click: function (val) {
                                //             // alert(this.category);
                                //             console.log(val, this.yCategory, this.series.data);
                                //             location.href = "#" + this.yCategory;
                                //         }
                                //     }
                                // }
                            }
                        },
                    });
                    this.loading2 = false;
                }
            },
            hit_color(color_data) {
                let color = "";
                if (color_data >= 200) {
                    color = "#f45151";
                } else if (color_data < 200 && color_data >= 80) {
                    color = "#f999b0";
                } else if (color_data < 80 && color_data >= 50) {
                    color = "#90ed7d";
                } else if (color_data < 50 && color_data >= 40) {
                    color = "#7cb5ec";
                } else if (color_data < 40) {
                    color = "#434348";
                }
                return color;
            },

        },

    }
    Array.prototype.pushNoRepeat = function() {
        for (var i = 0; i < arguments.length; i++) {
            var ele = arguments[i];
            if (this.indexOf(ele) == -1) {
                this.push(ele);
            }
        }
    };

    function isObj(object) {
        return object && typeof(object) == 'object' && Object.prototype.toString.call(object).toLowerCase() ==
            "[object object]";
    }

    function isArray(object) {
        return object && typeof(object) == 'object' && object.constructor == Array;
    }

    function getLength(object) {
        var count = 0;
        for (var i in object) {
            count++;
            i
        }
        return count;
    }
    function CompareArray(arrA, arrB){
        // console.log("CompareArray", arrA.length, arrB.length)
        if(arrA.length != arrB.length) return false;
        else{
            for(let i=0; i< arrA.length; i++){
                // console.log("CompareArray", arrA[i], arrB[i],arrA[i] !== arrB[i])
                if(arrA[i] !== arrB[i]){
                    return false;
                }
                if(arrA[i] != arrB[i]){
                    return false;
                }
            }
        }
        return true;
    }

    function Compare(objA, objB) {
        if (!isObj(objA) || !isObj(objB)) return false; //判断类型是否正确
        if (getLength(objA) != getLength(objB)) return false; //判断长度是否一致
        return CompareObj(objA, objB, true); //默认为true
    }

    function CompareObj(objA, objB, flag) {
        for (var key in objA) {
            if (!flag) //跳出整个循环
                break;
            if (!Object.prototype.hasOwnProperty.call(objB, key)) {
                flag = false;
                break;
            }
            if (!isArray(objA[key])) { //子级不是数组时,比较属性值
                if (objB[key] != objA[key]) {
                    flag = false;
                    break;
                }
            } else {
                if (!isArray(objB[key])) {
                    flag = false;
                    break;
                }
                var oA = objA[key],
                    oB = objB[key];
                if (oA.length != oB.length) {
                    flag = false;
                    break;
                }
                for (var k in oA) {
                    if (!flag) //这里跳出循环是为了不让递归继续
                        break;
                    flag = CompareObj(oA[k], oB[k], flag);
                }
            }
        }
        return flag;
    }
    getcolor

    function getcolor(arr) {
        let maplist = [
            ["A", "#f3a683"],
            ["B", "#8e44ad"],
            ["C", "#cf6a87"],
            ["D", "#e77f67"],
            ["E", "#f5cd79"],
            ["F", "#ea8685"],
            ["G", "#546de5"],
            ["H", "#e15f41"],
            ["I", "#c44569"],
            ["K", "#f8a5c2"],
            ["L", "#786fa6"],
            ["M", "#63cdda"],
            ["N", "#778beb"],
            ["P", "#596275"],
            ["Q", "#f19066"],
            ["R", "#f7d794"],
            ["S", "#574b90"],
            ["T", "#f78fb3"],
            ["U", "#34495e"],
            ["V", "#303952"],
            ["W", "#3dc1d3"],
            ["Y", "#e66767"],
            ["X", "#bdc3c7"],
            ["a", "#f3a683"],
            ["b", "#8e44ad"],
            ["c", "#cf6a87"],
            ["d", "#e77f67"],
            ["e", "#f5cd79"],
            ["f", "#ea8685"],
            ["g", "#546de5"],
            ["h", "#e15f41"],
            ["i", "#c44569"],
            ["k", "#f8a5c2"],
            ["l", "#786fa6"],
            ["m", "#63cdda"],
            ["n", "#778beb"],
            ["p", "#596275"],
            ["q", "#f19066"],
            ["r", "#f7d794"],
            ["s", "#574b90"],
            ["t", "#f78fb3"],
            ["u", "#34495e"],
            ["v", "#303952"],
            ["w", "#3dc1d3"],
            ["y", "#e66767"],
            ["x", "#bdc3c7"],
            ["A ", "#f3a683"],
            ["B ", "#8e44ad"],
            ["C ", "#cf6a87"],
            ["D ", "#e77f67"],
            ["E ", "#f5cd79"],
            ["F ", "#ea8685"],
            ["G ", "#546de5"],
            ["H ", "#e15f41"],
            ["I ", "#c44569"],
            ["K ", "#f8a5c2"],
            ["L ", "#786fa6"],
            ["M ", "#63cdda"],
            ["N ", "#778beb"],
            ["P ", "#596275"],
            ["Q ", "#f19066"],
            ["R ", "#f7d794"],
            ["S ", "#574b90"],
            ["T ", "#f78fb3"],
            ["U ", "#34495e"],
            ["V ", "#303952"],
            ["W ", "#3dc1d3"],
            ["Y ", "#e66767"],
            ["X ", "#bdc3c7"],
            ["a ", "#f3a683"],
            ["b ", "#8e44ad"],
            ["c ", "#cf6a87"],
            ["d ", "#e77f67"],
            ["e ", "#f5cd79"],
            ["f ", "#ea8685"],
            ["g ", "#546de5"],
            ["h ", "#e15f41"],
            ["i ", "#c44569"],
            ["k ", "#f8a5c2"],
            ["l ", "#786fa6"],
            ["m ", "#63cdda"],
            ["n ", "#778beb"],
            ["p ", "#596275"],
            ["q ", "#f19066"],
            ["r ", "#f7d794"],
            ["s ", "#574b90"],
            ["t ", "#f78fb3"],
            ["u ", "#34495e"],
            ["v ", "#303952"],
            ["w ", "#3dc1d3"],
            ["y ", "#e66767"],
            ["x ", "#bdc3c7"],
            [" ", "transparent"],
            ["-", "transparent"],
            ["*", "#353b48"]
        ]
        let colors = []
        for (var i = 0; i < arr.length; i++) {
            for (var j = 0; j < maplist.length; j++) {
                if (arr[i][0] === maplist[j][0]) {
                    colors.push(maplist[j][1])
                }
            }
        }
        // console.log("colors", colors)
        return colors
    }
</script>

<style>
    .table-header {
        background: #57606f;
        color: #ffffff;
    }

    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        color: #ffffff !important;
        background-color: #747d8c !important;
        border-right-color: #DCDFE6;
        border-left-color: #DCDFE6;
    }

    .el-tabs__item:hover {
        color: #ffffff !important;
        background-color: #a4b0be;
        cursor: pointer;
    }

    /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        border: 1px solid transparent;
        margin-top: -1px;
        color: #909399;
    }

    .el-tabs--border-card>.el-tabs__header {
        background-color: #F5F7FA;
        border-bottom: 0px solid #747d8c !important;
        margin: 0;
    }

    .el-tabs__item {
        box-sizing: border-box;
        height: 30px !important;
        line-height: 30px !important;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        position: relative;
    }

    .bm-table-ope p {
        margin: 1px 15px 0 15px;
    }

    .bm-table {
        margin-bottom: 8px;
    }

    table,
    td,
    tr,
    th {
        border-left: none !important;
        border-right: none !important;
    }

    .bm-table-name {
        background: #f1f2f6;
    }

    .el-input__inner{
        color: #4b6584 !important;
    }
</style>